import React, {useEffect, useState} from 'react';

const Loading = () => {
	const [count, setCount] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setCount((prevCount) => (prevCount + 1) % 101);
		}, 30); // Adjust speed as needed
		return () => clearInterval(interval);
	}, []);

	return (
		<div className="flex items-center justify-center h-screen overflow-hidden bg-[#1e0b26]">
			<div className="text-center">
				<div className="relative w-32 h-32">
					<div className="absolute inset-0 flex items-center justify-center">
						<span className="text-6xl text-white font-mono">{count}%</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Loading;